import { creditedTo, type ListenerDoc, type TrackDoc } from "radio-shared";
import { LikeButton } from "./LikeButton";

const mmss = (ms: number) => {
  const total = Math.max(0, Math.round(ms / 1000));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

export function NowPlaying({
  track,
  positionMs,
  live,
  myUid,
  listeners,
}: {
  track: TrackDoc | null;
  positionMs: number;
  live: boolean;
  myUid: string;
  listeners: ListenerDoc[];
}) {
  if (!track) {
    return (
      <section className="onair onair--silent">
        <p className="onair__silence">Silence radio</p>
        <p className="onair__hint">Rien n'est encore passé ici. Colle un lien, la radio s'allume.</p>
      </section>
    );
  }

  const progress = track.durationMs > 0 ? Math.min(100, (positionMs / track.durationMs) * 100) : 0;
  const isVoice = track.kind === "voice";
  // Lu sur le morceau plutôt que sur la station : il reste vrai si une dédicace
  // coupe la rediffusion et qu'elle reprend ensuite — c'est toujours la radio qui
  // comble, personne n'a rien mis entre-temps.
  const isRerun = track.rerun === true;
  const addedBy = creditedTo(track);
  const icon = isVoice ? "🎙️" : track.kind === "youtube" ? "▶" : "♫";

  return (
    <section className={`onair${isVoice ? " onair--voice" : ""}`}>
      <div className="onair__art">
        {track.thumbUrl ? (
          <img src={track.thumbUrl} alt="" />
        ) : (
          <span className="onair__art-fallback">{icon}</span>
        )}
      </div>

      <div className="onair__body">
        <p className="onair__label">
          {live ? (isVoice ? "À l'antenne" : "En direct") : "En pause"}
          {/* dire d'où sort ce son : personne ne l'a mis à l'instant, la radio
              est allée le rechercher */}
          {isRerun && <span className="onair__tag">rediffusion</span>}
        </p>
        <h1 className="onair__title">{track.title}</h1>
        {track.uploader && <p className="onair__sub">{track.uploader}</p>}

        <div className="bar" role="progressbar" aria-valuenow={Math.round(progress)}>
          <div className="bar__fill" style={{ width: `${progress}%` }} />
        </div>
        <div className="onair__times">
          <span>{mmss(positionMs)}</span>
          <span>{mmss(track.durationMs)}</span>
        </div>

        {/* Qui l'a mis, et ce que la salle en pense : la même ligne, parce que
            c'est la même question — d'où vient ce son et comment il est reçu. */}
        <div className="onair__footer">
          {/* Rien sur une rediffusion : elle n'est au crédit de personne, et la
              pastille dit déjà d'où sort le son. Le cœur, lui, reste : une
              rediffusion s'aime comme le reste. */}
          {addedBy && (
            <p className="onair__by">
              {track.addedByPhoto && <img className="avatar avatar--sm" src={track.addedByPhoto} alt="" />}
              mis par {addedBy}
            </p>
          )}
          <LikeButton track={track} myUid={myUid} listeners={listeners} />
        </div>
      </div>
    </section>
  );
}
